import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2987d4ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-scrollable modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title fs-3",
  id: "staticBackdropLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "fs-4" }
const _hoisted_8 = {
  class: "modal-backdrop fade show",
  id: "backdrop"
}

import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalMensagemDorape',
  props: ['visible', 'title', 'id', "text"],
  emits: ['modalResult'],
  setup(__props, { emit }) {

const props = __props;




function bloquearScroll() {
    setInterval(() => {
        // console.log(`${props.visible} - Modal Mensagem`);
        // (props.visible) ?
        //     document.querySelector("html")?.classList.add("overflow-hidden")
        //     :
        //     // "";
        //     document.querySelector("html")?.classList.remove("overflow-hidden");
    }, 100);
}
function ok() {
    document.querySelector("html")?.classList.remove("overflow-hidden");
    emit("modalResult", "ok", props.id);
}

onMounted(() => {
    bloquearScroll();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", {
      class: "modal fade show",
      id: __props.id,
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false",
      tabindex: "-1",
      "aria-labelledby": "staticBackdropLabel",
      "aria-modal": "true",
      style: {"display":"block","white-space":"pre-line"}
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.title), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(__props.text), 1)
          ]),
          _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: ok
            }, "Ok")
          ])
        ])
      ])
    ], 8, _hoisted_1), [
      [_vShow, __props.visible]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
      [_vShow, __props.visible]
    ])
  ], 64))
}
}

})